'use client';

import { useFormStatus } from 'react-dom';
import { Botao } from './Botao';

export function BotaoEnviar({ children, carregando }: { children: string; carregando: string }) {
  const { pending } = useFormStatus();
  return (
    <Botao type="submit" disabled={pending} className="w-full">
      {pending ? carregando : children}
    </Botao>
  );
}

export function Alerta({ mensagem }: { mensagem?: string }) {
  if (!mensagem) return null;
  return (
    <p className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
      {mensagem}
    </p>
  );
}
